import { BN } from "@project-serum/anchor";
import { Keypair, PublicKey, TransactionInstruction } from "@solana/web3.js";
import { serialize } from "borsh";
import { ClubAction } from "../enums/common.enums";
import { Rarity } from "../enums/staking.enum";

export interface IDetailNftData {
  name: string;
  description?: string;
  nftUrl: string;
  mint: PublicKey;
  owner?: PublicKey;
  price?: number;
  relatedProposal?: PublicKey;
  tokenAccount?: PublicKey;
  collection?: {
    family?: string;
    name: string;
    key?: string;
  };
  metadataAddress?: PublicKey;
  universeRarity?: Rarity;
  universeMetaData?: PublicKey;
}

export interface IDetailNftDataWithProposalInfo extends IDetailNftData {
  offer: PublicKey;
  makerOfferedTokens: PublicKey;
  maker: PublicKey;
  escrowOfferedTokensAccount: PublicKey;
  proposalPubkey: PublicKey;
  status: string;
  youWillGet?: number;
  isMagicEden: boolean;
}

export interface INftVoting extends IDetailNftData {
  nftVoteRecord?: PublicKey;
  votedWithNft: boolean;
}

export interface IFormField {
  name: string;
  label: string;
  initialValue: any;
  placeholder?: string;
}

export interface IOption {
  value: string;
  label: string;
  type?: number;
}

export interface IImgOption {
  value: string;
  label: string;
  imgUrl: string;
}

export interface ISocialNetwork {
  socialNetworkUrl: string;
  socialNetworkIcon: string;
}

export interface IVault {
  imgUrl: string;
  mint: string;
  tokenBalance: number;
}

//TODO@milica: check if this is needed
export enum VoterWeightAction {
  CastVote,
  CommentProposal,
  CreateGovernance,
  CreateProposal,
  SignOffProposal,
  CancelProposal,
}

export interface IInstructionSet {
  instructions: TransactionInstruction[];
  description: string;
  partialSigner?: Keypair;
  makeMagicEdenaApiCall?: boolean;
}

export class VoterWeightRecord {
  accountDiscriminator: Uint8Array;
  realm: PublicKey;
  governingTokenMint: PublicKey;

  governingTokenOwner: PublicKey;

  voterWeight: BN;
  voterWeightExpiry: BN | null;
  weightAction: VoterWeightAction | null;
  weightActionTarget: PublicKey | null;
  reserved: Uint8Array;

  constructor(args: {
    accountDiscriminator: Uint8Array;
    realm: PublicKey;
    governingTokenMint: PublicKey;

    governingTokenOwner: PublicKey;

    voterWeight: BN;
    voterWeightExpiry: BN | null;
    weightAction: VoterWeightAction | null;
    weightActionTarget: PublicKey | null;
    reserved: Uint8Array;
  }) {
    this.governingTokenMint = args.governingTokenMint;
    this.governingTokenOwner = args.governingTokenOwner;
    this.realm = args.realm;
    this.reserved = args.reserved;
    this.accountDiscriminator = args.accountDiscriminator;
    this.voterWeight = args.voterWeight;
    this.voterWeightExpiry = args.voterWeightExpiry;
    this.weightAction = args.weightAction;
    this.weightActionTarget = args.weightActionTarget;
  }
}

export interface ICollectionData {
  name: string;
  symbol: string;
  collectionImageUrl?: string;
  collectionAddress?: string;
  isVerified?: boolean;
}

export interface IExpandedPreviewData {
  label: string;
  amount: string;
  spanText?: string;
}
export interface IGetOrCreateTokenAccount {
  destination: PublicKey;
  instruction?: TransactionInstruction;
}

export class RoleDto {
  name: string;
  roleWeight: BN;
  clubActions: Uint8Array;
  membersCount: number;

  constructor(
    name: string,
    roleWeight: BN,
    clubActions: ClubAction[],
    membersCount: number
  ) {
    this.name = name;
    this.roleWeight = roleWeight;
    this.clubActions = new Uint8Array(clubActions);
    this.membersCount = membersCount;
  }

  serializeObj() {
    const schema = new Map([
      [
        RoleDto,
        {
          kind: "struct",
          fields: [
            ["name", "string"],
            ["roleWeight", "u64"],
            ["clubActions", [this.clubActions.length]],
            ["membersCount", "u32"],
          ],
        },
      ],
    ]);

    return serialize(schema, this);
  }
}

export class UpdateRoleConfig {
  config: {
    role: string;
    currentWeight: BN;
    updateWeight: BN;
  }[];
  constructor(args: {
    config: { role: string; currentWeight: BN; updateWeight: BN }[];
  }) {
    this.config = args.config;
  }
}
export interface ICreateTokenAcc {
  createAccountIx: TransactionInstruction;
  createInitAccountInstruction: TransactionInstruction;
  tokenAccount: Keypair;
}

//Temporary interface, will be import from node module
export interface IDelegation {
  // The creator of the delegation
  master: PublicKey;
  // The wallet who delegates
  representative: PublicKey;
  // Confirmation flag
  authorised: boolean;
}

export interface IFileUploadProps {
  accept: string;
  label: string;
  updateFilesCb: (files: any) => void;
  maxFileSizeInBytes?: number;
  multiple?: boolean;
  [otherProps: string]: any;
}
